const Brand = {

    // FIELDS
    "brand": "Brand",
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Brand",
    "filter_title": "Brand Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_description": "Description",
    
    // ERROR
    "error_name": "Enter Brand Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

}

export default Brand;

